"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Train = _interopRequireDefault(require("@material-ui/icons/Train"));
var _Place = _interopRequireDefault(require("@material-ui/icons/Place"));
var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));
var _HeroBoard = _interopRequireDefault(require("../components/HeroBoard"));
var _Item = _interopRequireDefault(require("../components/Item"));
var _excluded = ["icon", "content"];
var CruisePane = function CruisePane(_ref) {
  var title = _ref.title,
    departure = _ref.departure,
    returns = _ref.returns,
    vendor = _ref.vendor,
    reservationCode = _ref.reservationCode,
    address = _ref.address,
    phoneNumber = _ref.phoneNumber,
    backgroundImage = _ref.backgroundImage;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var list = [{
    icon: /*#__PURE__*/_react["default"].createElement(_Train["default"], {
      fontSize: "small"
    }),
    content: vendor
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], {
      fontSize: "small"
    }),
    content: reservationCode
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Phone["default"], {
      fontSize: "small"
    }),
    content: phoneNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Place["default"], {
      fontSize: "small"
    }),
    valign: 'top',
    content: address ? /*#__PURE__*/_react["default"].createElement("p", {
      className: "pb-2 whitespace-normal"
    }, address) : null
  }];
  return /*#__PURE__*/_react["default"].createElement("div", null, backgroundImage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-0 h-48 bg-no-repeat bg-cover",
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")")
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8 pr-4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "px-6 text-dark font-bold text-lg truncate"
  }, title), /*#__PURE__*/_react["default"].createElement(_HeroBoard["default"], {
    size: "sm",
    from: {
      label: t('sifts.modals.cruise.departs'),
      text: departure.date,
      subText: departure.time
    },
    to: !(0, _isNil["default"])(returns) ? {
      label: t('sifts.modals.cruise.returns'),
      text: returns.date,
      subText: returns.time
    } : undefined
  }), list.map(function (_ref2, index) {
    var icon = _ref2.icon,
      content = _ref2.content,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({}, rest, {
      key: index,
      size: "sm",
      icon: icon
    }), content);
  })));
};
var _default = exports["default"] = CruisePane;
//# sourceMappingURL=Cruise.js.map